import { useState } from 'react';
import { hotWords, rankTabData, rankTabs } from '@/mocks/ranking';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-secondary-500',
  flat: 'ri-subtract-line text-foreground-400',
  new: 'ri-flashlight-line text-accent-600',
};

const weightClass: Record<string, string> = {
  lg: 'text-base px-3 py-1.5 bg-accent-100 text-accent-900',
  md: 'text-sm px-3 py-1.5 bg-secondary-100 text-secondary-800',
  sm: 'text-xs px-2.5 py-1 bg-background-100 text-foreground-700',
};

export default function HotRanking() {
  const [tab, setTab] = useState('24h');
  const list = rankTabData[tab as keyof typeof rankTabData] ?? rankTabData['24h'];

  return (
    <aside id="ranking" className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center text-primary-600">
              <i className="ri-bar-chart-grouped-line" />
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-950">热度榜单</h3>
          </div>
          <span className="font-label text-[11px] tracking-widest text-foreground-500">LIVE</span>
        </div>

        <div className="px-4 py-3">
          <div className="inline-flex rounded-full bg-background-100 p-1">
            {rankTabs.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => setTab(item.id)}
                className={`rounded-full px-3 py-1 text-xs whitespace-nowrap cursor-pointer transition-colors ${
                  tab === item.id ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <ol className="flex flex-col px-4 pb-2">
          {list.map((item) => (
            <li key={`${tab}-${item.rank}`} className="flex items-center gap-3 border-b border-background-100 py-2.5 last:border-b-0">
              <span
                className={`font-label flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs ${
                  item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <span className="min-w-0 flex-1 truncate text-sm text-foreground-800" title={item.title}>
                {item.title}
              </span>
              <span className="hidden font-label text-xs text-foreground-700 sm:inline">{item.heat}</span>
              <span className="flex h-4 w-4 items-center justify-center">
                <i className={`${trendIcon[item.trend] ?? trendIcon.flat} text-xs`} />
              </span>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <div className="mb-3 flex items-center gap-2">
          <span className="flex h-5 w-5 items-center justify-center text-accent-600">
            <i className="ri-hashtag" />
          </span>
          <h3 className="font-heading text-base font-bold text-foreground-950">热词榜</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotWords.map((word) => (
            <span
              key={word.word}
              className={`rounded-full whitespace-nowrap cursor-pointer transition-colors hover:opacity-80 ${
                weightClass[word.weight] ?? weightClass.sm
              }`}
            >
              {word.word}
            </span>
          ))}
        </div>
      </div>
    </aside>
  );
}